import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SocialWidget from '../Widget/SocialWidget';
import Newsletter from '../Widget/Newsletter';
import IconBoxStyle11 from '../IconBox/IconBoxStyle11';
import Spacing from '../Spacing';
import { useTranslation } from 'react-i18next';

export default function Header({ logoSrc, variant }) {
  const { t, i18n } = useTranslation();
  const [isSticky, setIsSticky] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  const [sideNav, setSideNav] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language || 'fr');
  const [languageDropdown, setLanguageDropdown] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Close language dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (languageDropdown && !event.target.closest('.cs_language_selector')) {
        setLanguageDropdown(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [languageDropdown]);

  // Sync selectedLanguage with i18n changes
  useEffect(() => {
    const stored = typeof window !== 'undefined' ? localStorage.getItem('i18nextLng') : null;
    const current = (stored || i18n.language || 'fr').slice(0, 2);
    setSelectedLanguage(current);
    const handler = (lng) => setSelectedLanguage((lng || 'fr').slice(0, 2));
    i18n.on('languageChanged', handler);
    return () => {
      i18n.off('languageChanged', handler);
    };
  }, [i18n]);

  const changeLang = (lng) => {
    const normalized = lng.slice(0, 2);
    i18n.changeLanguage(normalized);
    try {
      localStorage.setItem('i18nextLng', normalized);
    } catch (_) {}
    setSelectedLanguage(normalized);
    setLanguageDropdown(false);
    // Nettoyer l'URL pour rester sur /
    if (window?.history?.replaceState) {
      window.history.replaceState(null, '', '/');
    }
  };
  return (
    <>
      <header
        className={`cs_site_header cs_style1 cs_sticky_header ${
          mobileToggle ? 'cs_mobile_toggle_active' : ''
        } ${variant} ${isSticky ? 'cs_active_sticky' : ''}`}
      >
        <div className="cs_main_header">
          <div className="container">
            <div className="cs_main_header_in">
              <div className="cs_main_header_left">
                <Link className="cs_site_branding" to="/">
                  <img src={logoSrc} alt="Logo" />
                </Link>
                <nav className="cs_nav">
                  <ul
                    className={`${
                      mobileToggle ? 'cs_nav_list cs_active' : 'cs_nav_list'
                    }`}
                  >
                    <li>
                      <Link to="/">{t('navigation.home')}</Link>
                    </li>
                    <li>
                      <Link to="/contact">{t('navigation.contact')}</Link>
                    </li>
                  </ul>
                  <span
                    className={
                      mobileToggle
                        ? 'cs_menu_toggle cs_teggle_active'
                        : 'cs_menu_toggle'
                    }
                    onClick={() => setMobileToggle(!mobileToggle)}
                  >
                    <span></span>
                  </span>
                </nav>
              </div>
              <div className="cs_main_header_right">
                <div className="cs_toolbox">
                  <div className="cs_language_selector">
                    <button
                      className="cs_language_btn"
                      type="button"
                      onClick={() => setLanguageDropdown(!languageDropdown)}
                    >
                      <span className="cs_language_flag">
                        {selectedLanguage === 'fr' ? '🇫🇷' : '🇬🇧'}
                      </span>
                      <span className="cs_language_code">
                        {selectedLanguage.toUpperCase()}
                      </span>
                      <svg
                        width="12"
                        height="8"
                        viewBox="0 0 12 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={`cs_dropdown_arrow ${languageDropdown ? 'active' : ''}`}
                      >
                        <path
                          d="M1 1.5L6 6.5L11 1.5"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    {languageDropdown && (
                      <div className="cs_language_dropdown">
                        <button
                          className={`cs_language_option ${selectedLanguage === 'fr' ? 'active' : ''}`}
                          onClick={() => changeLang('fr')}
                        >
                          <span className="cs_language_flag">🇫🇷</span>
                          <span>Français</span>
                        </button>
                        <button
                          className={`cs_language_option ${selectedLanguage === 'en' ? 'active' : ''}`}
                          onClick={() => changeLang('en')}
                        >
                          <span className="cs_language_flag">🇬🇧</span>
                          <span>English</span>
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className={`cs_sidenav ${sideNav ? 'active' : ''}`}>
        <div
          className="cs_sidenav_overlay"
          onClick={() => setSideNav(!sideNav)}
        />
        <div className="cs_sidenav_in">
          <button
            className="cs_close"
            type="button"
            onClick={() => setSideNav(!sideNav)}
          >
            <img src="/images/icons/close.svg" alt="Close" />
          </button>
          <div className="cs_logo_box">
            <img src="/images/logo-transvie.svg" alt="Logo" />
            <div className="cs_height_15" />
            <h3 className="cs_fs_24 cs_semibold mb-0">
              Your Partner in Health and Wellness
            </h3>
          </div>
          <Spacing md="35" lg="35" xl="35" />
          <hr />
          <Spacing md="35" lg="50" xl="35" />
          <IconBoxStyle11
            title="Phone"
            subTitle="123-456-7890"
            iconSrc="/images/contact/icon_1.svg"
          />
          <Spacing md="30" lg="30" xl="30" />
          <IconBoxStyle11
            title="Email"
            subTitle="hellocallcenter@gmail.com"
            iconSrc="/images/contact/icon_2.svg"
          />
          <Spacing md="30" lg="30" xl="30" />
          <IconBoxStyle11
            title="Location"
            subTitle="123 Anywhere St., Any City, 12345"
            iconSrc="/images/contact/icon_3.svg"
          />
          <Spacing md="60" lg="60" xl="60" />
          <Newsletter />
          <Spacing md="70" lg="50" xl="50" />
          <hr />
          <Spacing md="70" lg="50" xl="50" />
          <SocialWidget />
        </div>
      </div>
    </>
  );
}
